import { baseUrl } from "../../utils/env";
import axios from "axios";
import {
  GALLERY_ADD_FAIL,
  GALLERY_ADD_REQUEST,
  GALLERY_ADD_SUCCESS,
  GALLERY_DELETE_FAIL,
  GALLERY_DELETE_REQUEST,
  GALLERY_DELETE_SUCCESS,
  GALLERY_DETAIL_FAIL,
  GALLERY_DETAIL_REQUEST,
  GALLERY_DETAIL_SUCCESS,
  GALLERY_LIST_FAIL,
  GALLERY_LIST_REQUEST,
  GALLERY_LIST_SUCCESS,
  GALLERY_UPDATE_FAIL,
  GALLERY_UPDATE_REQUEST,
  GALLERY_UPDATE_SUCCESS,
} from "../constants/galleryConstant";
import { toast } from "react-toastify";

export const listGallery = () => async (dispatch) => {
  try {
    dispatch({ type: GALLERY_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/gallery`, config);

    dispatch({
      type: GALLERY_LIST_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: GALLERY_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const detailGallery = (uuid) => async (dispatch) => {
  try {
    dispatch({ type: GALLERY_DETAIL_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/gallery/${uuid}`, config);

    dispatch({
      type: GALLERY_DETAIL_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: GALLERY_DETAIL_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const addGallery = (title, imageArray) => async (dispatch, getState) => {
  try {
    dispatch({ type: GALLERY_ADD_REQUEST });
    const {
      adminLogin: { adminInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };
    const { data } = await axios.post(
      `${baseUrl}/gallery`,
      {
        title,
        imageArray,
      },
      config
    );

    toast.info("Gallery Added Successfully", {
      autoClose: 1000,
    });
    dispatch({
      type: GALLERY_ADD_SUCCESS,
      payload: data,
    });
  } catch (err) {
    toast.error("Fail To Add Gallery", {
      autoClose: 1000,
    });
    dispatch({
      type: GALLERY_ADD_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const updateGallery =
  (title, imageArray, galleryId) => async (dispatch, getState) => {
    try {
      dispatch({ type: GALLERY_UPDATE_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseUrl}/gallery/${galleryId}`,
        {
          title,
          imageArray,
        },
        config
      );

      toast.info("Gallery Updated Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: GALLERY_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Update Gallery", {
        autoClose: 1000,
      });
      dispatch({
        type: GALLERY_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
export const deleteGallery = (galleryId) => async (dispatch, getState) => {
  try {
    dispatch({ type: GALLERY_DELETE_REQUEST });
    const {
      adminLogin: { adminInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };
    const { data } = await axios.delete(
      `${baseUrl}/gallery/${galleryId}`,
      config
    );

    toast.info("Gallery Deleted Successfully", {
      autoClose: 1000,
    });
    dispatch({
      type: GALLERY_DELETE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    toast.error("Fail To Delete Gallery", {
      autoClose: 1000,
    });
    dispatch({
      type: GALLERY_DELETE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
